// src/constants/userBlocks.js
// Faz 1E Görev 2 — Kullanıcı engelleme (block) sözleşmesi.
//
// Tek kaynak; client service + feed/comments filtreleri (Görev 3) tarafından
// import edilir. Rule tarafı firestore.rules içinde ayrıca gate'lenir.

// Subcollection yolu bileşenleri: users/{blockerUid}/{BLOCK_SUBCOLLECTION}/{blockedUid}
export const BLOCK_SUBCOLLECTION = "blocked";

// Listeleme sınırları — bir kullanıcının engelli listesi çok uzayamaz (güvenli cap).
export const BLOCK_LIST_PAGE_SIZE = 500;

// Client cache TTL — getBlockedUids için. Block/unblock'ta cache zaten
// invalidate edildiğinden TTL'i 5 dk tutmak güvenli; sayfa gezinmelerinde
// tekrarlanan ~1000-doc okumalarını ~5x azaltır (maliyet).
export const BLOCK_CACHE_TTL_MS = 300_000;
